document.addEventListener(
  "click",
  function (e) {
    var btn = e.target.closest(
      "menu-drawer.c-mobile-facets--from-left .mobile-facets__header .mobile-facets__close",
    );
    if (!btn) return;
    var drawer = btn.closest("menu-drawer");
    if (!drawer) return;
    var details = drawer.querySelector("details.mobile-facets__disclosure");
    if (!details || !details.hasAttribute("open")) return;
    var summary = details.querySelector(":scope > summary");
    if (!summary) return;
    e.preventDefault();
    summary.click();
  },
  true,
);
